import { render } from "./projectTaskModal.vue?vue&type=template&id=14963730&ts=true"
import script from "./projectTaskModal.ts?vue&type=script&lang=ts"
export * from "./projectTaskModal.ts?vue&type=script&lang=ts"

import "./projectTaskModal.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__